module.exports = __webpack_public_path__ + "img/condition_th.407650bb.jpg";